import type { ThoughtGrouping } from "@/generated/fastapi";
import type { QuestionnaireViewModeSetting } from "../appSettings";
import type {
  ActiveStudioContentType,
} from "@/shared/types";

export const QUESTIONNAIRE_VIEW_THOUGHT_ORIENTED =
  "thought-oriented" as const;
export const QUESTIONNAIRE_VIEW_DIMENSION_ORIENTED =
  "dimension-oriented" as const;

export const QUESTIONNAIRE_VIEW_MODES = [
  QUESTIONNAIRE_VIEW_THOUGHT_ORIENTED,
  QUESTIONNAIRE_VIEW_DIMENSION_ORIENTED,
] as const satisfies readonly QuestionnaireViewModeSetting[];

export const QuestionnaireViewSelectOptions: Record<
  QuestionnaireViewModeSetting,
  string
> = {
  [QUESTIONNAIRE_VIEW_THOUGHT_ORIENTED]: "Thought-Oriented View",
  [QUESTIONNAIRE_VIEW_DIMENSION_ORIENTED]: "Dimension-Oriented View",
};

export const STUDIO_GROUPING_BY_SITUATION = "by_situation" as const;
export const STUDIO_GROUPING_FREE_LIST = "free_list" as const;

export const StudioGroupingOptions: Record<
  ThoughtGrouping,
  { label: string; description: string }
> = {
  [STUDIO_GROUPING_BY_SITUATION]: {
    label: "by situation",
    description: "Group thoughts by the situations they are anchored to.",
  },
  [STUDIO_GROUPING_FREE_LIST]: {
    label: "free list",
    description: "Display all thoughts in a single list.",
  },
};

export const STUDIO_CONTENT_CONFIRMED = "confirmed" as const;
export const STUDIO_CONTENT_SUGGESTED = "suggested" as const;

export const StudioContentOptions: Record<
  ActiveStudioContentType,
  { label: string; description: string }
> = {
  [STUDIO_CONTENT_CONFIRMED]: {
    label: "confirmed",
    description: "Show confirmed thoughts.",
  },
  [STUDIO_CONTENT_SUGGESTED]: {
    label: "suggested",
    description: "Show suggested thoughts.",
  },
};
